import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import actions from '../../../actions';
import { TDispatch } from '../../../reducers';
import { TInductionSession, TMeta, TPageNotification } from '../../../types';
import { InductionSessionCalendar } from './FullCalendar';
import { ConfirmUpdateInductionSession } from './ConfirmUpdate';

Modal.setAppElement('#react-root');

export type TInductionSessionSearchParams = {
    afterDate: string,
    beforeDate: string
}
type TInductionSessionProps = {
    load: (searchParams: TInductionSessionSearchParams) => void;
    content: TInductionSession[];
    meta: TMeta;
    fetching: boolean;
    notification: TPageNotification;
}

type TInductionSessionState = {
    scheduledEvents: TInductionSession[];
    currentDate: Date;
    beforeDate: string;
    afterDate: string;
    inductionSessions: any[];
    showAlertModal: boolean;
    eventInfo: any;
}

class InductionSession extends Component<TInductionSessionProps, TInductionSessionState> {
    state = {
        scheduledEvents: [] as TInductionSession[],
        currentDate: new Date(),
        beforeDate: '',
        afterDate: '',
        inductionSessions: [] as any,
        showAlertModal: false,
        eventInfo: null as any,
    };

    private timer: NodeJS.Timer;

    componentDidMount() {
        this.timer = setInterval(() => {
            this.setState({ currentDate: new Date() });
            }, 60000);
    }

    getDatesRange = (
        dateInfo: { start: Date ; end: Date }
    )=>  {
        const currentUrlParams = {
            afterDate: dateInfo.start.toISOString(),
            beforeDate: dateInfo.end.toISOString()
        };
        this.setState({ ...currentUrlParams });
        this.props.load(currentUrlParams);
    }

    getEventColor = (event: TInductionSession) => {
        const { currentDate } = this.state;

        if (new Date(event.start) < currentDate) {
          return '#C0C0C0';
        } if (event.title.includes('Construction')) {
          return '#228B22';
        } if (event.title.includes('Hospitality')) {
          return '#4b0082';
        } if (event.title.includes('Industrial')) {
          return '#20b2aa';
        } if (event.title.includes('Driving')) {
          return '#87cefa';
        } if (event.title.includes('Office')) {
          return '#5f9ea0';
        }
        return '#AB2B87';
      };

    updateSessionDateOnDrag = (clickedEventInfo: any)=> {
        this.setState({ showAlertModal: true, eventInfo: clickedEventInfo });
    }

    render() {
        const searchParams = {
            afterDate: this.state.afterDate,
            beforeDate: this.state.beforeDate
        };
        const modifiedEvents = this.props.content.map((event: TInductionSession) => ({
            ...event,
            color: this.getEventColor(event),
          }));

        return (
            <div>
                <InductionSessionCalendar
                    scheduledEvents={modifiedEvents}
                    currentDate={this.state.currentDate}
                    afterDate={this.state.afterDate}
                    beforeDate={this.state.beforeDate}
                    notification={this.props.notification}
                    updateEvent={this.updateSessionDateOnDrag}
                    datesRange={this.getDatesRange}
                    reloadData={() => this.props.load(searchParams)}
                />
                <Modal
                    className="none"
                    contentLabel="Update Induction Session Confirm"
                    isOpen={this.state.showAlertModal}
                    appElement={document.getElementById('#react-root')}
                    >
                    <ConfirmUpdateInductionSession
                        notification={this.props.notification}
                        closeModal={() => this.setState({ showAlertModal: false })}
                        eventInfo={this.state.eventInfo}
                        reloadData={() => this.props.load(searchParams)}
                    />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state: TInductionSessionState) => ({
    ...state.inductionSessions
});

const mapDispatchToProps = (dispatch: TDispatch) => ({
    load: (searchParams: TInductionSessionSearchParams) => {
        dispatch(actions.loadInductionSessions(searchParams));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(InductionSession);
